import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  Icon,
} from '@chakra-ui/react';
import { FiPieChart } from 'react-icons/fi';

export default function ReportModal({
  title, size, children, ...rest
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button
        onClick={onOpen}
        variant="unstyled"
        size="md"
        width="100%"
        color="brand.blue.600"
        textAlign="left"
        display="flex"
        align="center"
        justifyContent="flex-start"
        px={4}
        leftIcon={<Icon as={FiPieChart} boxSize={6} />}
        {...rest}
        _hover={{ color: 'brand.blue.700' }}
      >
        {title}
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size={size || '4xl'} scrollBehavior="inside">
        <ModalOverlay
          bg="blackAlpha.700"
          backdropFilter="blur(4px)"
        />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {children}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
